import { Http } from 'Core/utils'

import { Analytic, Dashboard } from 'Portals/Customer/entities'

import { baseBannerUrl, baseUrl } from './constants'

export const retrieveLandfills = (): Promise<Dashboard.Landfill[]> =>
	Http.get(`${baseUrl}/landfill-vs-non-landfill`)

export const retrieveServiceSiteLandfills = (): Promise<Dashboard.ServiceSiteLandfill[]> =>
	Http.get(`${baseUrl}/landfill-vs-non-landfill-per-service-site`)

export const retrieveLandfillStatistics = (): Promise<Dashboard.LandfillStatictics> =>
	Http.get(`${baseUrl}/landfill-statistics`)

export const retrieveTotalSpent = (): Promise<Dashboard.TotalSpent> =>
	Http.get(`${baseUrl}/total-spent`)

export const retrieveDashboardTitle = (): Promise<string[]> => Http.get(`${baseUrl}/companies`)

export const retrieveOrderSummary = (): Promise<Dashboard.OrderSummary[]> =>
	Http.get(`${baseUrl}/customer-orders/summary`)

export const retrieveOrderWaitingForResponse = (): Promise<Dashboard.WaitingForResponse[]> =>
	Http.get(`${baseUrl}/customer-orders/waiting-for-response`)

export const retrieveLanguages = (): Promise<Entity[]> => Http.get('/languages')

export const retrieveProfileServiceSite = (): Promise<Dashboard.ProfileServiceSite[]> =>
	Http.get(`${baseUrl}/profile/service-sites`)

export const retrieveInvoiceStatement = (): Promise<Dashboard.InvoiceStatement.Basic[]> =>
	Http.get(`${baseUrl}/customer-invoices/latest`)

export const retrievePowerBiCharts = (): Promise<Analytic.Basic[]> =>
	Http.get(`${baseUrl}/powerbi-charts`)

export const retrievePowerBiToken = (
	body: Analytic.Token.Request
): Promise<Analytic.Token.Response> => Http.post(`${baseUrl}/powerbi-charts/token`, body)

export const retrieveBanners = (): Promise<Dashboard.Banner.Basic[]> => Http.get(baseBannerUrl)

export const retrieveBanner = (id: Key): Promise<ArrayBuffer> =>
	Http.get(`${baseBannerUrl}/${id}/image`, {
		responseType: 'arraybuffer'
	})
